import { StyledSearchBar, useDebouncedSearch } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { useRecoilState } from 'recoil';
import { searchFenceState } from '../../storage/fences';

function FenceFilters() {
  const { search, setSearch } = useDebouncedSearch(useRecoilState(searchFenceState));

  return (
    <StyledSearchBar
      name={'fence-search'}
      value={search}
      onChange={(value) => setSearch(value)}
      clearable
      noMargin
    />
  );
}

export default memo(FenceFilters);
